import { render } from "./NetworkError.vue?vue&type=template&id=1f36ac7d"
const script = {}
script.render = render

export default script